import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiModule } from '../api.module';
import { UserTableVisualization } from '../../../data/model/user';
import { DictionaryApiService } from '../../../core/service/abstract/dictionary-api.service';
import { ENV_CONFIG, EnvironmentConfig } from '../../../core/enviroment-config';

@Injectable({
  providedIn: 'root',
})
export class DictionaryUserTableVisualizationApiService extends DictionaryApiService<UserTableVisualization> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('portal/auth/user-module-visual', http, config);
  }
}
